__turbopack_context__.v({
  "smallScreen": "small-screen-module___ROOKq__smallScreen",
});
